import React from 'react'
import { FormattedMessage } from 'react-intl'
import { Box, Grid, Container, Typography } from '@material-ui/core'
import isEmpty from 'lodash.isempty'
import { useStyles } from '../SchoolShow_style'
import HorizontalCardsSlider from 'components/HorizontalCardsSlider/HorizontalCardsSlider'
import ResponsiveVideo from 'components/ResponsiveVideo/ResponsiveVideo'
import ShowPageImages from 'components/ShowPageImages/ShowPageImages'
import KeyStats from 'components/KeyStats/KeyStats'
import SchoolFaq from './SchoolFaq'
import ArticleCardV2 from 'cards/ArticleCard/ArticleCardV2'

const SchoolOverview = (props) => {
    const { school } = props
    const classes = useStyles()

    return (
        <Container maxWidth='lg' disableGutters>
            {school.paid && !isEmpty(school.videos) &&
                <HorizontalCardsSlider wrappedArrows shift={300}>
                    {school.videos.map((video, index) => {
                        return (
                            <Box className={classes.videoBox} key={index}>
                                <ResponsiveVideo
                                    video={{ url: video.url, width: 250, height: 480 }}
                                />
                            </Box>
                        )
                    })}
                </HorizontalCardsSlider>
            }
            {school.paid && !isEmpty(school.school_facts) &&
                <Box className={classes.statsContainer}>
                    <KeyStats type='school' stats={school.school_facts} />
                </Box>
            }
            {school.paid && !isEmpty(school.articles) &&
                <Box className={classes.articleContainer}>
                    <Typography variant='h1' component='h2' className={classes.articleTitle}>
                        <FormattedMessage id='school_page.overview.article_title' values={{ school: school.name }}/>
                    </Typography>
                    <Box className={classes.articleBox}>
                        <Grid container spacing={2}>
                            {school.articles.map((article) => {
                                return (
                                    <Grid item xs={12} sm={6} md={4} key={`school-article-${article.title}`}>
                                        <ArticleCardV2 article={article}/>
                                    </Grid>
                                )
                            })}
                        </Grid>
                    </Box>
                </Box>
            }
            {school.paid && !isEmpty(school.faqs) &&
                <Box className={classes.statsContainer}>
                    <SchoolFaq school={school}/>
                </Box>
            }
            {!isEmpty(school.images) &&
                <Box className={classes.schoolBodyOverviewImages}>
                    <ShowPageImages images={school.images}/>
                </Box>
            }
        </Container>
    )
}

export default SchoolOverview
